import { registerLocaleData } from '@angular/common';
import { Component } from '@angular/core';
import { CoreLibService } from 'core-lib';
import localeDe from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import localeFR from '@angular/common/locales/fr';
import localeES from '@angular/common/locales/es';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(private coreLibService: CoreLibService ) {
    this.coreLibService.inlcudeGlobalStyles();
    this.coreLibService.inlcudeGlobalHooks();

    switch ($localize.locale) {
      case 'en':
        registerLocaleData(localeEN);
        break;
      case 'de':
        registerLocaleData(localeDe);
        break;
      case 'es':
        registerLocaleData(localeES);
        break
      case 'fr':
        registerLocaleData(localeFR);
        break;
      default:
        registerLocaleData(localeEN);
    }
  }
}
